<template>
    <Breadcrumbs main="Paramètres" mains="Paramètres" title="Accueil" />
    <div class="container-fluid">
        <div class="edit-profile">
            <div class="row">
                <EditGeneralSettings :settings="generalSettings" />
                <EditHomeSettings :settings="generalSettings" />
                <EditReportSettings :settings="generalSettings" />
                <EditAccountSettings :settings="generalSettings" />
                <div class="row">
                    <div class="col">
                        <div class="text-end">
                            <a
                                class="btn btn-success me-1"
                                target="_blank"
                                @click="save()"
                                >{{ $t('save') }}</a
                            >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import config from '@/config';
import { ref, defineAsyncComponent, onMounted, computed } from 'vue';
import ApiServices from '@/services/apiServices';
import { useLoaderState } from '@/store/loading';
import type { appsettings } from '@/core/data/appsettings';
import { error_message, success_message } from '@/components/common/toast';

const { t } = useI18n();
const route = useRoute();

const EditGeneralSettings = defineAsyncComponent(
    () => import('@/components/theme/settings/EditGeneralSettings.vue'),
);
const EditHomeSettings = defineAsyncComponent(
    () => import('@/components/theme/settings/EditHomeSettings.vue'),
);
const EditReportSettings = defineAsyncComponent(
    () => import('@/components/theme/settings/EditReportSettings.vue'),
);
const EditAccountSettings = defineAsyncComponent(
    () => import('@/components/theme/settings/EditAccountSettings.vue'),
);

const me = ref({});
const townId = ref('');
const generalSettings = ref<appsettings>({
    welcomeMessage: '',
    homeMessageEnabled: false,
    nbDaysAfterNewsEnabled: false,
    reportEmailNotificationEnabled: false,
    reportEmailAttachPdf: false,
    reportPdfShowPhone: false,
    nbDaysAfterNews: 100,
    homeMessage: '',
    homeMessageType: 'NONE',
    reportReceivedEmail: '',
    accountSettingsFireBase: '',
});

const isSuperAdmin = computed(() => {
    const user = JSON.parse(localStorage.getItem('user')!);
    return (
        user !== null &&
        user.token !== null &&
        user.user.role !== null &&
        user.user.role === config.role.superAdmin
    );
});

const save = async () => {
    useLoaderState().changeStateTrue();
    try {
        if (townId.value) {
            const payload: any = {
                welcomeMessage: generalSettings.value.welcomeMessage,
                homeMessageEnabled: generalSettings.value.homeMessageEnabled,
                homeMessage: generalSettings.value.homeMessage,
                homeMessageType: generalSettings.value.homeMessageType,
                reportEmailNotificationEnabled:
                    generalSettings.value.reportEmailNotificationEnabled,
                reportEmailAttachPdf:
                    generalSettings.value.reportEmailAttachPdf,
                reportPdfShowPhone: generalSettings.value.reportPdfShowPhone,
                reportReceivedEmail: generalSettings.value.reportReceivedEmail,
                nbDaysAfterNewsEnabled:
                    generalSettings.value.nbDaysAfterNewsEnabled,
                nbDaysAfterNews: generalSettings.value.nbDaysAfterNews,
            };
            if (isSuperAdmin.value) {
                payload.firebaseServiceAccount =
                    generalSettings.value.accountSettingsFireBase;
            }

            await ApiServices.patch(
                'town',
                payload,
                `/settings/${townId.value}`,
            );

            success_message(t('settingsEdit.updated'));
        }
    } catch (err) {
        error_message(err.message);
    }
    useLoaderState().changeStateFalse();
};

const getDatas = async () => {
    const meResponse: any = await ApiServices.get('users/me', {});
    me.value = meResponse;
    townId.value = (route.query.id as string) ?? meResponse.townId;

    const town: any = await ApiServices.getById('town', townId.value);
    const settings = town?.settings ?? {};

    generalSettings.value.welcomeMessage = settings.welcomeMessage ?? '';
    generalSettings.value.homeMessageEnabled =
        settings.homeMessageEnabled ?? false;
    generalSettings.value.homeMessage = settings.homeMessage ?? '';
    generalSettings.value.homeMessageType = settings.homeMessageType ?? 'NONE';
    generalSettings.value.reportEmailNotificationEnabled =
        settings.reportEmailNotificationEnabled ?? false;
    generalSettings.value.reportEmailAttachPdf =
        settings.reportEmailAttachPdf ?? false;
    generalSettings.value.reportPdfShowPhone =
        settings.reportPdfShowPhone ?? false;
    generalSettings.value.reportReceivedEmail =
        settings.reportReceivedEmail ?? '';
    generalSettings.value.nbDaysAfterNewsEnabled =
        settings.nbDaysAfterNewsEnabled ?? false;
    generalSettings.value.nbDaysAfterNews = settings.nbDaysAfterNews ?? 100;
    generalSettings.value.accountSettingsFireBase =
        settings.firebaseServiceAccount ?? '';
};

onMounted(() => {
    useLoaderState().changeStateTrue();
    getDatas().finally(() => useLoaderState().changeStateFalse());
});
</script>
